<template>
    <div class="contenedor-enlace-album">
        <a :href="link" class="enlace-imagen a11y-simplificada-block" target="_blank" >

            <picture>
                <source
                :srcset="imagen_lap"
                media="(min-width: 769px)"
                />
                <img :srcset="imagen_cel" alt="" />
            </picture>
            <!--<img :src="imagen" :alt="titulo">-->
        </a>
        <a :href="link" class="enlace-texto" target="_blank">
            
            <span  class="icono icono-atras"></span>
            {{titulo}}
        </a>
    </div>
</template>


<script>
export default {
    props:['link','imagen_lap','imagen_cel','titulo']
}
</script>

<style lang="scss">
.contenedor-enlace-album{
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    &:hover,
    &:focus {
        box-shadow: 0 8px 16px rgba(0,0,0,.4);
        
    }
    .enlace-imagen{
        img{
            border-radius: 10px;
        }
        &:hover{
            background-color: white;
        }
    }
    .enlace-texto{
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-weight: 400;
        color:#141414;
        margin-bottom: 5px;
        .icono-atras{
            transform: rotate(180deg);
            background: #ddd;
            height: 30px;
            font-size: 40px;
            line-height: 30px;
            width: 30px;
            border-radius: 30px;
            text-align: center;
            font-weight: 400;
            display: inline-block;
            transition: all 0.2s;
            margin-right: 8px;
            margin-left: 13px;
            color: #39594D
        }
        &:hover{
            background-color: transparent;
            color:#141414;
            font-weight: 500;
        }
    }
}
</style>